import { State } from '../../../../store/types';
import { LoadingState } from '../../../Campaign/types';
import { SLICE_NAME } from './types';

export const selectSigninInfluencerShowLoading = () => (state: State) =>
  state[SLICE_NAME].loadingState === LoadingState.PENDING;

export const selectSigninInfluencerError = () => (state: State) =>
  state[SLICE_NAME].error;
